import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-solar-design',
  standalone: true,
  imports: [],
  templateUrl: './solar-design.component.html',
  styleUrl: './solar-design.component.scss'
})
export class SolarDesignComponent implements OnInit {
  environment: any = environment;
  constructor(public utils: UtilsService, private metaSvc: MetaMgmtService) {
    let metaData: any = {
      canonicalURL: 'https://www.luminousindia.com/sub-category/solar-design',
      description: 'Get expert solar panel design help instantly! No site visits needed. Optimize your solar project with efficient, hassle-free design solutions by Luminous.',
      pageTitle: 'Solar Panel Design - Instant Solar Design Assistance Without Site Visits'
    }
    this.metaSvc.updateMetaTags(metaData);
   }

  ngOnInit(): void {
    this.utils.showLoading();
  }

  viewPDF(url: string) {
    window.open(url, '_blank');
  }

  imageLoaded() {
    this.utils.hideLoading();
  }
}
